/* OPTIONLESS – Effekte nach Magic UI (vanilla, ohne React). Läuft nach theme.js (defer). */
(function () {
  'use strict';
  window.OLFX = true;
  var root = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var cfg = (window.OL && window.OL.fx) || {};
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var hasIO = 'IntersectionObserver' in window;

  /* Blur Fade beim Reinscrollen (nur Startseite) */
  if (root.classList.contains('fx') && document.body.classList.contains('t-index') && hasIO && !reduced) {
    var targets = [];
    var mark = function (el, i) { if (!el || el.hasAttribute('data-fx')) return; el.setAttribute('data-fx', ''); if (i) el.style.setProperty('--i', i); targets.push(el); };
    $$('main .section-head').forEach(function (el) { mark(el); });
    $$('main .tiles').forEach(function (g) { $$(':scope > .tile', g).forEach(function (el, i) { mark(el, i); }); });
    $$('main .grid').forEach(function (g) { $$(':scope > .outfit, :scope > .card', g).forEach(function (el, i) { mark(el, i % 4); }); });
    $$('main .bundle, main .community, main .split__media, main .trust').forEach(function (el) { mark(el); });
    $$('main .athletes').forEach(function (g) { $$(':scope > *', g).forEach(function (el, i) { mark(el, i % 4); }); });
    /* Statement Wort für Wort (Text Animate) */
    $$('main .statement').forEach(function (el) {
      if (el.querySelector('*:not(br)')) return;
      var html = el.innerHTML.split(/(<br\s*\/?>)/i).map(function (part) {
        if (/^<br/i.test(part)) return part;
        return part.split(/(\s+)/).map(function (w) { return /^\s+$/.test(w) || !w ? w : '<span class="fx-word">' + w + '</span>'; }).join('');
      }).join('');
      el.innerHTML = html;
      $$('.fx-word', el).forEach(function (w, i) { w.style.setProperty('--w', i); });
      el.classList.add('fx-words'); el.setAttribute('data-fx-words', ''); targets.push(el);
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('fx-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.95 && r.bottom > 0) el.classList.add('fx-in'); else io.observe(el);
    });
    /* Sicherheitsnetz: nach 6 s alles sichtbar */
    setTimeout(function () { targets.forEach(function (el) { el.classList.add('fx-in'); }); }, 6000);
  } else {
    root.classList.remove('fx');
  }

  /* Marquee: anhalten, wenn nicht sichtbar oder Tab im Hintergrund */
  $$('.marquee').forEach(function (m) {
    if (!hasIO) return;
    new IntersectionObserver(function (en) { m.classList.toggle('is-paused', !en[0].isIntersecting); }).observe(m);
  });
  document.addEventListener('visibilitychange', function () { $$('.marquee').forEach(function (m) { m.classList.toggle('is-paused', document.hidden); }); });

  /* Border Beam */
  if (cfg.beam !== false && !reduced) {
    $$('main .bundle, main .community').forEach(function (el) {
      if (el.querySelector('.fx-beam__track')) return;
      el.classList.add('fx-beam');
      var t = document.createElement('span'); t.className = 'fx-beam__track'; t.setAttribute('aria-hidden', 'true');
      el.appendChild(t);
      if (hasIO) new IntersectionObserver(function (en) { el.classList.toggle('is-visible', en[0].isIntersecting); }).observe(el);
      else el.classList.add('is-visible');
    });
  }

  /* Magic Card: Lichtkegel folgt der Maus (Desktop) */
  if (cfg.spotlight !== false && fine && !reduced) {
    $$('main .tile, main .bundle, main .community').forEach(function (el) {
      el.classList.add('fx-spot');
      var raf = 0, x = 0, y = 0;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect(); x = e.clientX - r.left; y = e.clientY - r.top;
        if (raf) return;
        raf = requestAnimationFrame(function () { el.style.setProperty('--mx', x + 'px'); el.style.setProperty('--my', y + 'px'); raf = 0; });
      }, { passive: true });
    });
  }

  /* Lens: Lupe auf Produktbildern (Desktop) */
  if (cfg.lens !== false && fine && window.matchMedia('(min-width: 990px)').matches) {
    var Z = 2.2;
    $$('.gallery__item .media').forEach(function (m) {
      var img = m.querySelector('img'); if (!img) return;
      m.classList.add('has-lens');
      var lens = document.createElement('span'); lens.className = 'fx-lens'; lens.setAttribute('aria-hidden', 'true'); m.appendChild(lens);
      var size = 200, ready = false, raf = 0, px = 0, py = 0;
      function hiSrc() {
        var src = img.currentSrc || img.src;
        try { var u = new URL(src, location.href); u.searchParams.set('width', '2000'); return u.toString(); } catch (e) { return src; }
      }
      function prep() {
        if (ready) return; ready = true;
        lens.style.backgroundImage = 'url("' + hiSrc() + '")';
        if (m.classList.contains('media--light')) lens.style.backgroundBlendMode = 'multiply';
      }
      function box() {
        var r = m.getBoundingClientRect(), ir = img.getBoundingClientRect(), cs = getComputedStyle(img);
        var pl = parseFloat(cs.paddingLeft) || 0, pt = parseFloat(cs.paddingTop) || 0;
        var cw = ir.width - pl - (parseFloat(cs.paddingRight) || 0), ch = ir.height - pt - (parseFloat(cs.paddingBottom) || 0);
        var nw = img.naturalWidth || cw, nh = img.naturalHeight || ch;
        var k = cs.objectFit === 'contain' ? Math.min(cw / nw, ch / nh) : Math.max(cw / nw, ch / nh);
        var w = nw * k, h = nh * k;
        return { x: ir.left - r.left + pl + (cw - w) / 2, y: ir.top - r.top + pt + (ch - h) / 2, w: w, h: h };
      }
      function draw() {
        raf = 0;
        var b = box();
        lens.style.backgroundSize = (b.w * Z) + 'px ' + (b.h * Z) + 'px';
        lens.style.backgroundPosition = (-((px - b.x) * Z - size / 2)) + 'px ' + (-((py - b.y) * Z - size / 2)) + 'px';
        lens.style.setProperty('--lx', (px - size / 2) + 'px'); lens.style.setProperty('--ly', (py - size / 2) + 'px');
      }
      m.addEventListener('pointerenter', function () { prep(); lens.classList.add('is-on'); });
      m.addEventListener('pointerleave', function () { lens.classList.remove('is-on'); });
      m.addEventListener('pointermove', function (e) {
        var r = m.getBoundingClientRect(); px = e.clientX - r.left; py = e.clientY - r.top;
        if (!raf) raf = requestAnimationFrame(draw);
      }, { passive: true });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') $$('.fx-lens.is-on').forEach(function (l) { l.classList.remove('is-on'); }); });
  }
})();
